import createPalette from "@material-ui/core/styles/createPalette";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    gardient?: {
      default?: string;
      medium?: string;
      hover?: string;
    };
  }

  interface PaletteOptions {
    gardient?: {
      default?: string;
      medium?: string;
      hover?: string;
    };
  }

  interface Palette {
    blueGray?: {
      main?: string;
    };
  }

  interface PaletteOptions {
    blueGray?: {
      main?: string;
    };
  }

  interface Palette {
    purple?: {
      main?: string;
      dark?: string;
    };
  }

  interface PaletteOptions {
    purple?: {
      main?: string;
      dark?: string;
    };
  }

  interface Palette {
    indigo?: PaletteOptions["purple"];
  }

  interface PaletteOptions {
    indigo?: PaletteOptions["purple"];
  }

  interface PaletteOptions {
    scgPrimary?: {
      main?: string;
      hover?: string;
      dark?: string;
    };
  }

  interface Palette {
    scgPrimary?: {
      main?: string;
      hover?: string;
      dark?: string;
    };
  }
}
const Palette = createPalette({
  success: {
    light: "#6CC04A",
    dark: "#1E7D34",
    main: "#28A745"
  },
  info: {
    main: "#009FB8",
    dark: "#007E92"
  },
  grey: {
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#CCCCCC",
    "500": "#999999",
    "600": "#696969",
    "700": "#555555",
    "800": "#333333",
    "900": "#222222"
  },
  blueGray: {
    main: "#A3AED0"
  },
  indigo: {
    main: "#3860BE"
  },
  error: {
    main: "#E41B17",
    light: "#FF2600",
    dark: "#BF0000"
  },
  warning: {
    main: "#FD7E14",
    light: "#FFC107"
  },
  purple: {
    main: "#601863",
    dark: "#3B1F6C"
  },
  background: {
    default: "#F4F7FE"
  },
  gardient: {
    default:
      "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
    medium: "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
    hover:
      "linear-gradient(0deg, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)"
  },
  scgPrimary: {
    main: "#FF2600",
    hover: "#FFF2F6",
    dark: "#BF0000"
  }
});

export default Palette;
